import EmailActivity from './EmailActivity';

export default EmailActivity;
